import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import KategoriDeviceDialog from "../add/KategoriDeviceDialog";
import KategoriMerkDialog from "../add/KategoriMerkDialog";
import KategoriChecklistQCDialog from "../add/KategoriChecklistQCDialog";
import { axiosInstance as axios, endpoint } from "../../../../api/axios";
import { useSelector } from "react-redux";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FieldDeviceDialog = ({
  // dataDevice,
  dataMyDevice,
  pageSize,
  dataTemplateDevice,
  openDevice,
  handleCloseDevice,
  onSelect,
}) => {
  const [searchValue, setSearchValue] = useState("");

  const [namaDevice, setNamaDevice] = useState("");

  const [selectedKategoriDevice, setSelectedKategoriDevice] = useState(null);

  const [selectedMerk, setSelectedMerk] = useState(null);

  const [selectedQC, setSelectedQC] = useState(null);

  const [openKategoriDevice, setOpenKategoriDevice] = useState(false);

  const [openMerk, setOpenMerk] = useState(false);

  const [openQC, setOpenQC] = useState(false);

  const [dataDeviceKategori, setDataDeviceKategori] = useState([]);

  const [dataDeviceMerk, setDataDeviceMerk] = useState([]);

  const user = useSelector(
      (state) => state.user.users[state.user.currentUserId]
    );

  // const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const handleOpenKategoriDevice = () => {
    setOpenKategoriDevice(true);
  };
  const handleCloseKategoriDevice = () => {
    setOpenKategoriDevice(false);
  };

  const handleOpenMerk = () => {
    if (!selectedKategoriDevice) return;
    setOpenMerk(true);
  };
  const handleCloseMerk = () => {
    setOpenMerk(false);
  };

  const handleOpenQC = () => {
    setOpenQC(true);
  };
  const handleCloseQC = () => {
    setOpenQC(false);
  };


  // Master Data Device Kategori
  
    useEffect(() => {
      const getDataKategoriDevice = async () => {
        try {
          if (user?.token) {
            const response = await axios.post(
              endpoint.MasterDataService.DeviceKategori,
              {
                page: currentPage,
                pageSize: pageSize,
              },
              {
                headers: {
                  Authorization: `${user.token_type} ${user.token}`,
                },
              }
            );
  
            const data = response.data.data?.data;
            setDataDeviceKategori(data || []);
            setTotal(response.data.total);
          }
        } catch (error) {
          console.error("Data gagal dieksekusi", error);
        }
      };
      getDataKategoriDevice();
    }, [currentPage, pageSize]);

     // Master Data Device Merk
  
     useEffect(() => {
      const getDataMerkDevice = async () => {
        try {
          if (user?.token) {
            const response = await axios.post(
              endpoint.MasterDataService.DeviceMerk,
              {
                page: currentPage,
                pageSize: pageSize,
              },
              {
                headers: {
                  Authorization: `${user.token_type} ${user.token}`,
                },
              }
            );
  
            const data = response.data.data?.data;
            setDataDeviceMerk(data || []);
            setTotal(response.data.total);
          }
        } catch (error) {
          console.error("Data gagal dieksekusi", error);
        }
      };
      getDataMerkDevice();
    }, [currentPage, pageSize]);
  

  const optionsKategoriDevice = [
    { name: "Laptop" },
    { name: "HP" },
    { name: "Scanner" },
  ];

  const optionsMerk = [
    { name: "Asus", category: "Laptop" },
    { name: "HP", category: "Laptop" },
    { name: "Samsung", category: "HP" },
    { name: "Canon", category: "Scanner" },
  ];

  const optionsQC = [
    {
      name: "Laptop",
      components: [
        "Layar / LCD",
        "Keyboard",
        "Touchpad",
        "Baterai",
        "Charger / Adapter",
        "Port USB",
        "Port HDMI",
        "Speaker",
        "WiFi",
        "Bluetooth",
        "Webcam",
        "Body / Fisik",
        "Operating System",
      ],
    },
    {
      name: "HP",
      components: [
        "Layar / LCD",
        "Tombol Power & Volume",
        "Touchscreen",
        "Kamera Depan",
        "Kamera Belakang",
        "Port Charger",
        "Port Headset",
        "Speaker",
        "Mikrofon",
        "WiFi",
        "Bluetooth",
        "Fingerprint / Face ID",
        "SIM Card",
        "Body / Fisik",
        "Operating System",
      ],
    },
    {
      name: "Scanner",
      components: [
        "Sensor Pemindai",
        "Penutup Scanner",
        "Kabel Power",
        "Kabel Data (USB)",
        "Tombol Operasi",
        "Lampu Indikator",
        "Driver & Software",
        "Body / Fisik",
        "Hasil Scan",
      ],
    },
  ];
  

  const handleSelectKategoriDevice = (device) => {
    setSelectedKategoriDevice(device);
    setSelectedMerk(null);
    setOpenKategoriDevice(false);
  };

  const handleSelectMerk = (merk) => {
    setSelectedMerk(merk);
    setOpenMerk(false);
  };

  const handleSelectQC = (qc) => {
    setSelectedQC(qc);
    setOpenQC(false);
  };

  const colors = ["#f8bbd0", "#b2ebf2", "#c5e1a5", "#ffe082", "#d1c4e9"];

  const [selectedTab, setSelectedTab] = useState(
    "MyDevice"
  );
  
  // const [selectedTab, setSelectedTab] = useState(
  //   Object.keys(dataDevice)[0] || ""
  // );

  // const filteredDevice = dataDevice[selectedTab]?.filter(
  //   (device) =>
  //     device.name.toLowerCase().includes(searchValue.toLowerCase()) ||
  //     device.jenis.includes(searchValue)
  // );

  // const filteredMerk = selectedKategoriDevice
  //   ? optionsMerk.filter((m) => m.category === selectedKategoriDevice.name)
  //   : [];

  // Filter dataMyDevice
  const filteredMyDevice = dataMyDevice.filter((device) =>
    device.name.toLowerCase().includes(searchValue.toLowerCase()) ||
    device.category_name.includes(searchValue)
  );

  // Filter dataTemplateDevice
  const filteredTemplateDevice = dataTemplateDevice.filter((template) =>
    template.name.toLowerCase().includes(searchValue.toLowerCase()) ||
    template.category_name.includes(searchValue)
  );

// Jika ada input, tampilkan semua hasil filter, jika kosong, batasi dengan slice
const isSearching = searchValue.trim() !== "";

const displayedMyDevice = isSearching
  ? filteredMyDevice
  : filteredMyDevice.slice(0, pageSize);

const displayedTemplateDevice = isSearching
  ? filteredTemplateDevice
  : filteredTemplateDevice.slice(0, pageSize);


  return (
    <Dialog
      fullScreen
      open={openDevice}
      onClose={handleCloseDevice}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Browse Device
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseDevice}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Cari Device"
          variant="outlined"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#fff",
            borderRadius: 2,
            mb: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
        />

        <Tabs
          value={selectedTab}
          onChange={(e, newValue) => setSelectedTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 2, bgcolor: "#ffffff", borderRadius: 2 }}
        >
          {/* {Object.keys(dataDevice).map((category) => (
            <Tab label={category} value={category} key={category} />
          ))} */}
          <Tab label="My Device" value="MyDevice" key="MyDevice" />
          <Tab label="Template" value="Template" key="Template" />
          <Tab label="Manual" value="Manual" key="Manual" />
        </Tabs>
        {selectedTab !== "Manual" && (
          <Box
            sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 2 }}
          >
            <Box
              sx={{
                bgcolor: "rgba(33, 150, 243, 0.1)", // biru transparan
                color: "#2196f3",
                borderRadius: "50%",
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ReportProblemOutlinedIcon fontSize="small" />
            </Box>

            <Box>
              <Typography
                variant="caption"
                color="text"
                gutterBottom
                sx={{ mb: 1 }}
              >
                Tidak menemukan device
              </Typography>

              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                gutterBottom
              >
                Cari dari template atau tambah manual
              </Typography>
            </Box>
          </Box>
        )}
        {selectedTab === "MyDevice" &&  (
        displayedMyDevice.map((device, index) => (
          <Box
            key={index}
            onClick={() => onSelect(device)}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#ffffff",
              boxShadow: 1,
              mb: 1,
              cursor: "pointer",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: colors[index % colors.length],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                {/* Inisial nama (huruf pertama) */}
                <Typography variant="subtitle2" fontWeight="bold">
                  {(
                    device.name.charAt(0) +
                    device.name.charAt(device.name.length - 1)
                  ).toUpperCase()}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  {device.name}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  {device.category_name}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))
      )}
      {selectedTab === "Template" &&  (
        displayedTemplateDevice.map((device, index) => (
          <Box
            key={index}
            onClick={() => onSelect(device)}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#ffffff",
              boxShadow: 1,
              mb: 1,
              cursor: "pointer",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: colors[index % colors.length],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                {/* Inisial nama (huruf pertama) */}
                <Typography variant="subtitle2" fontWeight="bold">
                  {(
                    device.name.charAt(0) +
                    device.name.charAt(device.name.length - 1)
                  ).toUpperCase()}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  {device.name}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  {device.category_name}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))
      )}
        {selectedTab === "Manual" && (
          <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#fff", mb: 2 }}>


        <Typography variant="body1" color="text.secondary">
            Fitur ini akan segera hadir
          </Typography>
            
            {/* Input Data Manual Comming Soon 
            <Typography
              variant="body2"
              fontWeight="bold"
              color="text.primary"
              sx={{ mb: 1 }}
            >
              Nama Device
            </Typography>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Masukkan nama device"
              value={namaDevice}
              onChange={(e) => setNamaDevice(e.target.value)}
              sx={{
                bgcolor: "#fff",
                borderRadius: 2,
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <Typography
              variant="body2"
              fontWeight="bold"
              color="text.primary"
              sx={{ mb: 1 }}
            >
              Kategori
            </Typography>
            <TextField
              fullWidth
              size="small"
              label="Pilih Kategori Device"
              placeholder="Pilih Kategori Device"
              value={selectedKategoriDevice ? selectedKategoriDevice.name : ""}
              variant="outlined"
              onClick={handleOpenKategoriDevice}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                bgcolor: "#fff",
                borderRadius: 2,
                mb: 2,
                cursor: "pointer",
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <Typography
              variant="body2"
              fontWeight="bold"
              color="text.primary"
              sx={{ mb: 1 }}
            >
              Merk
            </Typography>
            <TextField
              fullWidth
              size="small"
              label="Pilih Kategori Merk"
              placeholder="Pilih Kategori Merk"
              value={selectedMerk ? selectedMerk.name : ""}
              variant="outlined"
              onClick={handleOpenMerk}
              disabled={!selectedKategoriDevice}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                bgcolor: "#fff",
                borderRadius: 2,
                mb: 2,
                cursor: !selectedKategoriDevice ? "not-allowed" : "pointer",
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <Typography
              variant="body2"
              fontWeight="bold"
              color="text.primary"
              sx={{ mb: 1 }}
            >
              Checklist QC (Opsional)
            </Typography>
            <TextField
              fullWidth
              size="small"
              label="Pilih Checklist QC"
              placeholder="Pilih Checklist QC"
              value={selectedQC ? selectedQC : ""}
              variant="outlined"
              onClick={handleOpenQC}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                bgcolor: "#fff",
                borderRadius: 2,
                mb: 4,
                cursor: "pointer",
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <Button
              variant="contained"
              fullWidth
              sx={{
                textTransform: "none",
                bgcolor: "#424242",
                borderRadius: 5,
                ":hover": {
                  bgcolor: "#08306b",
                },
              }}
            >
              Tambah
            </Button> */}
          </Box>
        )}
      </Box>
      <KategoriDeviceDialog
        // dataKategoriDevice={optionsKategoriDevice}
        dataKategoriDevice={dataDeviceKategori}
        openKategoriDevice={openKategoriDevice}
        handleCloseKategoriDevice={handleCloseKategoriDevice}
        onSelect={handleSelectKategoriDevice}
      />
      <KategoriMerkDialog
        // dataMerk={optionsMerk}
        dataMerk={dataDeviceMerk}
        openMerk={openMerk}
        handleCloseMerk={handleCloseMerk}
        onSelect={handleSelectMerk}
      />

    <KategoriChecklistQCDialog
        dataQC={optionsQC}
        openQC={openQC}
        handleCloseQC={handleCloseQC}
        onSelect={handleSelectQC}
      />
    </Dialog>
  );
};

export default FieldDeviceDialog;
